import { useContext } from 'react';
import { EchoContext } from './Provider';

export default function useEcho() {
  return useContext(EchoContext);
}
